import { IStudentDetails } from '../types';

export const EMPTY_STUDENT_DETAILS: IStudentDetails = {
  studentId: '',
  institution: '',
  course: '',
  courseEndDate: undefined,
};
